let hinweise = [];

export default {
  getHinweise() {
    return hinweise;
  },

  getUnreadHinweise() {
    if (hinweise != null && hinweise.length > 0) {
      const ungelesene = hinweise.filter(f => f.gelesen !== 'true');
      return ungelesene;
    }

    return [];
  },

  setHinweise: function (data) {
    if (!data) return;
    hinweise = data;
  },  

  hasUnreadHinweise() {
    if (hinweise != null && hinweise.length > 0) {
      const ungelesene = hinweise.filter(f => f.gelesen === 'false');
      return ungelesene.length > 0;
    }

    return false;
  },

  setGelesen(id) {
    if (hinweise != null && hinweise.length > 0) {
      const hinweis = hinweise.filter(f => f.id === id)[0];
      hinweis.gelesen = "true";
    }
  }
}
